import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { logoutWithDelay } from 'store/oauth/service';

export const initialState: IDevicesState = {
  selectedDevices: []
};

const slice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    onChangeSelection: (state, action: PayloadAction<{ devices: IDeviceListItem[] }>) => {
      state.selectedDevices = action.payload.devices;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logoutWithDelay.fulfilled, () => initialState);
  }
});

export const { onChangeSelection } = slice.actions;
export const devicesReducer = slice.reducer;
